<template>
  <div class="mt-12" id="loginForm">
    <h1 class="mb-3 text-center">{{ title }}</h1>

    <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;">
      
      <!-- <v-btn
        class="login-with-google-btn"
        @click="login"
      >
        {{ $vuetify.lang.t("$vuetify.view.signIn.loginGoogleTitle") }}
      </v-btn>
       -->

      <login-with-google :clickFunc="login" />
      <login-with-apple :clickFunc="loginWithApple" />

    </div>

    <p v-if="!showPhoneForm" class="phone-info-text text-center mt-6">
      {{ isRegistration ? $vuetify.lang.t("$vuetify.view.signIn.registrationProviderOnly") : $vuetify.lang.t("$vuetify.view.signIn.smsDisabled") }}
    </p>
    <template v-else>
    <div class="or-block">
      <div class="line"></div>
      <div class="text">
        {{ $vuetify.lang.t("$vuetify.view.signIn.or") }}
      </div>
      <div class="line"></div>
    </div>

    <p class="phone-info-text text-center" v-if="isRegistration">
      {{ $vuetify.lang.t("$vuetify.view.signIn.phoneTextReg1") }}
    </p>
    <p class="phone-info-text text-center" v-else>
      {{ $vuetify.lang.t("$vuetify.view.signIn.phoneText1") }}<br>
      {{ $vuetify.lang.t("$vuetify.view.signIn.phoneText2") }}
    </p>

    <vue-phone-number-input
      @verify="onSubmit"
      @keydown.native.enter="sendPhoneNumber"
      v-model="userPhoneNumber"
      :loader="hasLoaderActive"
      :error="hasErrorActive"
      :default-country-code="defaultCountry"
      :only-countries="countriesList"
      show-code-on-list
      required
      @update="updatedData"
      :translations="translations"
      clearable
    />
    <!-- <vue-phone-number-input
      @verify="onSubmit"
      @keydown.native.enter="sendPhoneNumber"
      v-model="userPhoneNumber"
      :loader="hasLoaderActive"
      :error="hasErrorActive"
      :default-country-code="defaultCountry"
      :countries-height="0"
      
      :only-countries="countriesList"
      show-code-on-list

      required
      @update="updatedData"
      :translations="translations"
      clearable
    />

    <vue-phone-number-input
      @verify="onSubmit"
      @keydown.native.enter="sendPhoneNumber"
      v-model="userPhoneNumber"
      :loader="hasLoaderActive"
      :error="hasErrorActive"
      :default-country-code="defaultCountry"
      :preferred-countries="countriesList"
      show-code-on-list
      required
      @update="updatedData"
      :translations="translations"
      clearable
    /> -->

    <!-- add in this button data-action with correct actioon, here logic for login&register user -->
    <v-btn
      ref="submitButton"
      :disabled="!userData.isValid"
      class="send-code"
      :loading="loading"
      color="primary"
      outlined
      @click="sendPhoneNumber"
    >
      {{ isRegistration ? $vuetify.lang.t("$vuetify.view.signIn.continueBtn") : $vuetify.lang.t("$vuetify.view.signIn.code") }}
      <template v-slot:loader>
        <span>{{ $vuetify.lang.t("$vuetify.view.signIn.loading") }}</span>
      </template>
    </v-btn>

    </template>
    <p class="mt-6 small-text text-center text-sm-body-2 font-weight-regular">
      {{ $vuetify.lang.t("$vuetify.view.signIn.termsPart1") }}
      <terms>{{ $vuetify.lang.t("$vuetify.view.signIn.termsPart2") }}</terms>
      {{ $vuetify.lang.t("$vuetify.view.signIn.termsPart3")
      }}<personal-data>{{
        $vuetify.lang.t("$vuetify.view.signIn.termsPart4")
      }}</personal-data>
      {{ $vuetify.lang.t("$vuetify.view.signIn.termsPart5") }}
    </p>
    
    <!-- <p class="mt-4 small-text text-center text-sm-body-2 font-weight-regular old-login-link">
    <router-link :to="{ name: 'oldAuth' }">
      <span>
        {{ $vuetify.lang.t("$vuetify.view.signIn.oldLoginLink1") }}
        {{ $vuetify.lang.t("$vuetify.view.signIn.oldLoginLink2") }}
      </span>
    </router-link>
    </p> -->
    <!-- <vue-tel-input 
      v-model="userPhoneNumber" 
      mode="international"
      :dropdownOptions="{
        showFlags: true,
        disabled: true
      }"
      ></vue-tel-input> -->
  </div>
</template>

<script>
const Terms = () => import("@/components/UI/personalTerms/terms");
const PersonalData = () => import("@/components/UI/personalTerms/personalData");
const LoginWithGoogle = () => import("@/components/UI/LoginWithGoogle");
const LoginWithApple = () => import("@/components/UI/LoginWithApple");

/* import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css' */

//import Vue from "vue";

export default {
  name: "signInComponent",
  components: { PersonalData, Terms, LoginWithGoogle, LoginWithApple/* , VueTelInput */ },
  
  mounted() {
    // Load the reCAPTCHA script when the component is mounted
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?render="+process.env.VUE_APP_RECAPTCHA_KEY;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    if (this.$route.query.redirect) {
      this.$store.commit("user/SET_REDIRECT", this.$route.query.redirect);
    } else {
      this.$store.commit("user/SET_REDIRECT", null);
    }
  },


  data() {
    return {
      userPhoneNumber: null,
      updateValue: "",
      defaultCountry: "",
      countriesList: ["UA"],
      hasLoaderActive: false,
      hasErrorActive: false,
      loader: null,
      loading: false,
      verifyUrl: "",
      userData: {},
      option: "",
      users: {
        admin: "successfully_sent_to_a_phone",
        simple: "successfully_sent_to_phone",
      },
    };
  },
  watch: {
    userData() {
      let countryCode = this.userData.countryCode;
      let nationalNumber = this.userData.nationalNumber;
      switch (countryCode) {
        case "UA":
          if (nationalNumber) {
            if (Array.from(nationalNumber).length > 9) {
              this.hasErrorActive = true;
              this.userData.isValid = false;
            } else {
              this.hasErrorActive = false;
            }
          }
      }
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
  },
  created() {
    this.defaultCountry = this.getPhoneCountryCode || "UA";
    this.verifyUrl = this.$route.meta.url;
    this.option = this.$route.meta.option;
    this.userPhoneNumber = this.$store.getters["user/getUserPhone"];
  },
  computed: {
    isRegistration() {
      return this.option === "patientReg" || this.option === "psychReg";
    },
    showPhoneForm() {
      // new users register only with Google/Apple; SMS stays for users who registered by phone earlier
      if (this.isRegistration) return false;
      return this.$store.getters["settings/smsLoginEnabled"];
    },
    getPhoneCountryCode() {
      return this.$store.getters["user/getUserPhoneCountryCode"];
    },
    title() {
      return this.$vuetify.lang.t(this.$route.meta.title);
    },
    translations() {
      return {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t("$vuetify.view.signIn.example"),
      };
    },
  },
  methods: {
    loginWithApple() {
      this.$store.commit("user/SET_USER_PHONE", {
        phone: "",
        code: "",
      });

      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", false);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/apple`;
    },
    login() {
      this.$store.commit("user/SET_USER_PHONE", {
        phone: "",
        code: "",
      });

      this.$store.commit("user/SET_PROCESS_LINKING_LOGIN", false);

      let base = process.env.VUE_APP_API.replace(/\/+$/, '');
      window.location.href = `${base}/api/auth/login/google`;
      /* window.google.accounts.oauth2.initTokenClient({
        client_id: process.env.VUE_APP_GOOGLE_OAUTH2_CLIENT_ID,
        scope: "openid email profile",
        callback: (resp) => {
          let payload = {
            provider: 'google',
            token: resp.access_token,
          };
          this.loader = "loading";
          this.$store
            .dispatch('user/loginSocial', JSON.stringify(payload))
            // eslint-disable-next-line no-unused-vars
            .then((response) => {
              if (response.status === 200) {
                let authParam = this.$store.getters["user/getAuthParam"];
                let url = '/dashboard/main';
                let redirect = this.$route.query.redirect || url;
                if(authParam.userRole == "admin" || authParam.userRole == "redactor") {
                  redirect = '/dashboard/blog';
                }
                this.$router.push(redirect);
                Vue.swal({
                  target: document.getElementById("main"),
                  text: response.data.message,
                  icon: "success",
                  timer: 4000,
                  toast: true,
                  position: "top-right",
                  showConfirmButton: false,
                });
                this.$store.commit("user/SET_ADMIN_TRIGGER", false);
              }
            })
            .catch((error) => {
              if (error instanceof TypeError) {
                this.$router.replace("/auth");
              }
              if (error.code === "user_not_exists") {
                this.$store.commit("user/SET_LOGIN_PROVIDER", {
                  provider: error.login_provider,
                  provider_id: error.login_provider_id,
                });

                this.$router.replace("/registration");
              }
              if (error.code === "user_deleted") {
                this.$store.commit("user/SET_AUTH_TOKEN", error.access_token);
                this.$router.replace("/restore");
              }
            })
            .finally(() => {
              this.loader = false;
            });
        }
      }).requestAccessToken(); */
    },
    onSubmit() {
      this.$refs.submitButton.$el.click();
    },
    updatedData(data) {
      this.userData = data;
    },
    setDispatchType(option) {
      switch (option) {
        case "auth":
          return "user/sendCode";
        case "psychReg":
          return "user/sendUserRegCode";
        case "patientReg":
          return "user/sendUserRegCode";
      }
    },
    async sendPhoneNumber() {
      if (this.userData.isValid) {
        this.$store.commit("user/SET_USER_PHONE", {
          phone: this.userData.formattedNumber,
          code: this.userData.countryCode,
        });

        //new patient/psychologist registrations no longer go through SMS verification -
        //just collect the phone number and move straight to the next step
        if (this.option === "patientReg" || this.option === "psychReg") {
          this.$router.push({
            path: this.option === "patientReg" ? "/signUp" : "/psychologistRegForm/email",
            query: { redirect: this.$route.query.redirect },
          });
          return;
        }

        this.loader = "loading";

        this.$store.commit("user/SET_LOGIN_PROVIDER", {
          provider: null,
          provider_id: null,
        });

        const recaptchaKey = process.env.VUE_APP_RECAPTCHA_KEY;
        const recaptchaToken = recaptchaKey && window.grecaptcha
          ? await new Promise(resolve => {
              window.grecaptcha.execute(recaptchaKey, { action: 'submit' }).then(token => resolve(token));
            })
          : null;

        let payload = {
          phone: this.userData.formattedNumber,
          recaptchaToken: recaptchaToken,
        };
        await this.$store
          .dispatch(this.setDispatchType(this.option), JSON.stringify(payload))
          // eslint-disable-next-line no-unused-vars
          .then((response) => {
            this.$store.commit(
              "user/SET_ADMIN_TRIGGER",
              response.data.code === "successfully_sent_to_a_phone"
            );
            this.$router.push({
              path: this.verifyUrl,
              query: { redirect: this.$route.query.redirect }
            });
          })
          .catch((error) => {
            if (error instanceof TypeError) {
              this.$store.commit("user/SET_USER_PHONE", {
                phone: this.userData.formattedNumber,
                code: this.userData.countryCode,
              });
              this.$router.replace("/auth");
            }
            if (error.code === "user_deleted") {
              this.$store.commit(
                "user/SET_ADMIN_TRIGGER",
                false
              );
              this.$router.push({
                path: this.verifyUrl,
                query: { redirect: this.$route.query.redirect }
              });
            }
            if (error.code === "user_not_exists")
              this.$router.replace("/registration");
          })
          .finally(() => {
            this.loader = false;
          });
        this.$store.commit("user/SET_USER_PHONE", {
          phone: this.userData.formattedNumber,
          code: this.userData.countryCode,
        });
      }
    },
  },
};
</script>

<style scoped>

.old-login-link a {
  text-decoration: none;
}

#loginForm {
  margin: 0 auto;
  max-width: 400px;
  padding: 0px 16px;
}

h1 {
  color: #00A3B7;
  font-weight: 400;
  font-size: 30px;
}

.phone-info-text {
  margin-top: 14px;
  margin-bottom: 22px;
  color: 575756;
  font-size: 16px;
}




.text-center {
  text-align: center;
}

.or-block {
  display: flex;
  align-items: center;
  column-gap: 30px;

  color: #00A3B7;
  font-size: 20px;
  margin-top: 20px;
}

.or-block .line {
  height: 1px;
  background: #C5C5C5;
  flex-grow: 1;
}



.send-code {
  width: 100%;
  margin-top: 20px;
}

.small-text {
  color: #848484;
  font-size: 13px !important;
}
</style>
